export const heroData = {
  tag: "热门剧集 每日更新",
  title: "草民影院",
  subtitle: "高清不卡，即点即看的追剧天堂",
  slogan: "国产剧 · 韩剧 · 美剧 一站畅享",
  description:
    "草民影院汇聚全网热门电视剧全集，覆盖国产剧、韩剧、美剧等主流频道，每日同步更新最新剧集。无论你是想一口气刷完经典老剧，还是追更当下最火的爆款新番，这里都能满足你。高清画质、流畅播放，告别卡顿和模糊，让每一帧画面都清晰动人。",
  stats: [
    { label: "每日更新", value: "200+" },
    { label: "覆盖剧集", value: "10000+" },
    { label: "高清画质", value: "1080P+" },
  ],
  primaryCta: { label: "开始追剧", href: "#cards" },
  secondaryCta: { label: "热度榜单", href: "#ranking" },
  heroImage:
    "https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20abstract%20composition%20with%20warm%20deep%20red%20and%20amber%20gradients%2C%20film%20reel%20silhouettes%2C%20soft%20dramatic%20lighting%2C%20movie%20theater%20curtain%20textures%2C%20elegant%20and%20artistic%20atmosphere%2C%20no%20text%2C%20dark%20background%20with%20rich%20crimson%20accents%2C%20cinematic%20mood%2C%20high%20contrast%2C%20abstract%20film%20elements%20scattered%20with%20warm%20glow&width=1200&height=900&seq=hero-cinema-01&orientation=portrait",
};

export const cardsData = [
  {
    id: 1,
    title: "庆余年 第二季",
    category: "古装权谋 · 国产剧",
    description: "范闲身世之谜逐步揭开，京都风云再起，朝堂博弈进入白热化阶段。",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20scholar%20in%20traditional%20robes%20standing%20in%20grand%20hall%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20historical%20Chinese%20architecture%2C%20dramatic%20shadows%2C%20rich%20textures%2C%20dark%20wood%20tones%2C%20no%20text&width=800&height=500&seq=card-qyn-01&orientation=landscape",
    tag: "热播中",
    tagColor: "primary",
  },
  {
    id: 2,
    title: "繁花",
    category: "年代商战 · 国产剧",
    description: "九十年代上海滩，阿宝在商海沉浮中书写一段传奇人生。",
    image:
      "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%20with%20neon%20lights%2C%20vintage%20cars%2C%20stylish%20people%20in%20retro%20fashion%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20noir%20atmosphere%2C%20rainy%20street%20reflections%2C%20dramatic%20lighting%2C%20no%20text&width=800&height=500&seq=card-fh-01&orientation=landscape",
    tag: "高分推荐",
    tagColor: "accent",
  },
  {
    id: 3,
    title: "黑暗荣耀",
    category: "复仇悬疑 · 韩剧",
    description: "年少时遭受校园暴力的女子，精心策划了一场跨越十余年的复仇。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20drama%20moody%20scene%20with%20elegant%20woman%20in%20dark%20attire%2C%20minimalist%20modern%20interior%2C%20cold%20blue%20and%20warm%20amber%20contrast%20lighting%2C%20mysterious%20atmosphere%2C%20reflective%20surfaces%2C%20dramatic%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=card-hary-01&orientation=landscape",
    tag: "口碑炸裂",
    tagColor: "primary",
  },
  {
    id: 4,
    title: "最后生还者",
    category: "末日生存 · 美剧",
    description: "真菌感染毁灭文明二十年后，幸存者乔尔带着少女艾莉穿越废土。",
    image:
      "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20landscape%20with%20abandoned%20city%20overgrown%20with%20nature%2C%20warm%20sunset%20light%20breaking%20through%20ruins%2C%20survivor%20silhouettes%2C%20cinematic%20wide%20shot%2C%20atmospheric%20dust%20particles%2C%20emotional%20mood%2C%20no%20text&width=800&height=500&seq=card-lou-01&orientation=landscape",
    tag: "HBO出品",
    tagColor: "accent",
  },
  {
    id: 5,
    title: "三体",
    category: "科幻巨制 · 国产剧",
    description: "纳米科学家汪淼与刑警史强共同揭开三体文明入侵地球的序幕。",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20cosmic%20background%2C%20three%20suns%20in%20alien%20sky%2C%20mysterious%20radio%20telescope%20array%2C%20deep%20space%20atmosphere%2C%20cool%20teal%20and%20warm%20orange%20contrast%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=card-st-01&orientation=landscape",
    tag: "年度巨制",
    tagColor: "primary",
  },
];

export const carouselData = [
  {
    id: 1,
    title: "2024 国产古装剧井喷",
    subtitle: "从《庆余年》到《长相思》，古装题材迎来黄金时代",
    description:
      "今年国产古装剧在制作水准和故事深度上都有质的飞跃，服化道精良、剧情紧凑，吸引了大量观众回归。",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20grand%20hall%20with%20ornate%20golden%20decorations%2C%20flowing%20silk%20curtains%2C%20warm%20lantern%20light%2C%20cinematic%20wide%20angle%2C%20rich%20red%20and%20gold%20color%20palette%2C%20atmospheric%20haze%2C%20no%20text&width=1600&height=700&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "韩剧复仇题材霸屏",
    subtitle: "《黑暗荣耀》《财阀家的小儿子》引发全网讨论",
    description:
      "韩剧复仇爽剧持续输出高能剧情，精致制作与深刻社会议题结合，成为年度最受关注的海外剧类型。",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20Korean%20luxury%20penthouse%20interior%20with%20floor%20to%20ceiling%20windows%20overlooking%20city%20skyline%20at%20night%2C%20minimalist%20elegant%20design%2C%20dramatic%20contrast%20lighting%2C%20moody%20atmosphere%2C%20cinematic%20composition%2C%20no%20text&width=1600&height=700&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "美剧史诗级回归",
    subtitle: "《最后生还者》《龙之家族》等顶级IP改编引爆期待",
    description:
      "好莱坞顶级制作团队将游戏和文学经典搬上荧幕，每集堪比电影的制作水准让观众大呼过瘾。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20medieval%20dragon%20flying%20over%20castle%20at%20sunset%2C%20cinematic%20wide%20shot%2C%20dramatic%20clouds%2C%20warm%20golden%20hour%20light%2C%20silhouetted%20towers%2C%20atmospheric%20and%20grand%20scale%2C%20no%20text&width=1600&height=700&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "悬疑剧成新流量密码",
    subtitle: "《狂飙》《漫长的季节》开启国产悬疑新纪元",
    description:
      "现实题材悬疑剧凭借扎实的剧本和炸裂的演技成为年度黑马，观众追剧热情持续高涨。",
    image:
      "https://readdy.ai/api/search-image?query=Mysterious%20rainy%20alleyway%20in%20Chinese%20small%20town%20at%20night%2C%20neon%20sign%20reflections%20on%20wet%20ground%2C%20solitary%20figure%20in%20trench%20coat%2C%20noir%20atmosphere%2C%20cinematic%20lighting%2C%20deep%20shadows%2C%20moody%20green%20and%20amber%20tones%2C%20no%20text&width=1600&height=700&seq=carousel-04&orientation=landscape",
  },
  {
    id: 5,
    title: "科幻题材破圈而出",
    subtitle: "《三体》成功证明中国科幻剧集的无限可能",
    description:
      "从特效到叙事，《三体》以世界级水准打开了国产科幻剧的大门，让行业看到了新的方向。",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20holographic%20displays%20and%20cosmic%20window%20view%2C%20advanced%20technology%2C%20cool%20blue%20and%20white%20lighting%2C%20clean%20minimalist%20design%2C%20cinematic%20sci-fi%20aesthetic%2C%20no%20text&width=1600&height=700&seq=carousel-05&orientation=landscape",
  },
  {
    id: 6,
    title: "短剧赛道异军突起",
    subtitle: "微短剧以快节奏、强反转成为年轻人的新宠",
    description:
      "每集几分钟的微短剧凭借高密度剧情和碎片化观看体验，在年轻观众群体中迅速走红。",
    image:
      "https://readdy.ai/api/search-image?query=Young%20people%20watching%20phone%20in%20modern%20cozy%20cafe%2C%20warm%20ambient%20lighting%2C%20contemporary%20urban%20lifestyle%2C%20soft%20bokeh%20background%2C%20relaxed%20atmosphere%2C%20cinematic%20color%20grading%2C%20no%20text&width=1600&height=700&seq=carousel-06&orientation=landscape",
  },
];

export const indexData = [
  {
    id: 1,
    name: "国产剧",
    icon: "ri-tv-2-line",
    description: "古装权谋、都市情感、悬疑刑侦",
    count: "3260+ 部",
  },
  { id: 2, name: "韩剧", icon: "ri-heart-pulse-line", description: "浪漫爱情、复仇爽剧、职场生活", count: "1850+ 部" },
  { id: 3, name: "美剧", icon: "ri-global-line", description: "科幻史诗、犯罪悬疑、喜剧经典", count: "2100+ 部" },
  { id: 4, name: "日剧", icon: "ri-sun-line", description: "温暖治愈、社会写实、漫画改编", count: "1560+ 部" },
  { id: 5, name: "泰剧", icon: "ri-anchor-line", description: "青春校园、豪门恩怨、奇幻爱情", count: "890+ 部" },
  { id: 6, name: "古装剧", icon: "ri-building-2-line", description: "仙侠玄幻、宫廷权谋、武侠江湖", count: "1420+ 部" },
  { id: 7, name: "悬疑剧", icon: "ri-search-eye-line", description: "烧脑推理、犯罪心理、反转不断", count: "980+ 部" },
  { id: 8, name: "喜剧", icon: "ri-emotion-laugh-line", description: "轻松解压、家庭欢乐、职场笑料", count: "760+ 部" },
  { id: 9, name: "动漫", icon: "ri-movie-2-line", description: "热血冒险、治愈日常、国漫崛起", count: "2450+ 部" },
];

export const contactData = {
  title: "投稿与合作",
  description:
    "草民影院欢迎各位剧迷投稿剧评、推荐片单，也期待与优质内容创作者和版权方建立合作。你的每一次分享，都可能成为其他观众发现好剧的契机。",
  email: "contact@caomin.tv",
  wechat: "caomin_tv",
  methods: [
    { icon: "ri-mail-line", label: "邮箱投稿", value: "contact@caomin.tv" },
    { icon: "ri-wechat-line", label: "微信公号", value: "草民影院" },
    { icon: "ri-message-2-line", label: "在线留言", value: "点击下方按钮" },
  ],
};

export const updatesData = [
  {
    id: 1,
    date: "2024-07-30",
    content: "《庆余年第二季》全集更新完毕，范闲命运大结局揭晓，点击立即观看完整剧情。",
    tag: "新剧上线",
  },
  {
    id: 2,
    date: "2024-07-28",
    content: "《繁花》4K修复版独家上线，重温九十年代上海滩的黄金岁月与商海传奇。",
    tag: "高清修复",
  },
  {
    id: 3,
    date: "2024-07-25",
    content: "韩剧《黑暗荣耀》第二季全集更新，文东恩复仇计划最终章，高能反转不断。",
    tag: "热门更新",
  },
  {
    id: 4,
    date: "2024-07-22",
    content: "美剧《最后生还者》第二季预告发布，2025年重磅回归，末日之旅再度启程。",
    tag: "即将上线",
  },
  {
    id: 5,
    date: "2024-07-19",
    content: "《三体》网飞版与腾讯版对比专题上线，两版各有千秋引发观众热议。",
    tag: "专题策划",
  },
  {
    id: 6,
    date: "2024-07-16",
    content: "暑期档追剧指南发布：15部必看新剧推荐，涵盖国产、韩剧、美剧全类型。",
    tag: "追剧指南",
  },
  {
    id: 7,
    date: "2024-07-12",
    content: "《唐朝诡事录之西行》开播即爆，古装悬疑再出神作，豆瓣评分飙升8.5。",
    tag: "口碑新剧",
  },
  {
    id: 8,
    date: "2024-07-08",
    content: "草民影院APP新版上线，支持离线缓存和弹幕互动，追剧体验全面升级。",
    tag: "平台动态",
  },
];

export const commentsData = [
  {
    id: 1,
    author: "追剧小能手",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20silhouette%20with%20warm%20orange%20gradient%20background%2C%20simple%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20facial%20details&width=80&height=80&seq=avatar-01&orientation=squarish",
    content:
      "草民影院真的太良心了！更新速度超快，画质也是真的1080P不缩水。以前在别的地方看剧总是卡顿，来这边之后彻底告别转圈圈，追剧体验直接拉满。",
    drama: "庆余年 第二季",
    time: "2 小时前",
  },
  {
    id: 2,
    author: "深夜剧迷人",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20silhouette%20with%20amber%20gradient%20background%2C%20simple%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20facial%20details&width=80&height=80&seq=avatar-02&orientation=squarish",
    content:
      "作为一个韩剧重度爱好者，这里的韩剧资源太全了！《黑暗荣耀》全集一口气看完，爽到飞起。而且没有乱七八糟的弹窗广告，看剧完全不被打扰。",
    drama: "黑暗荣耀",
    time: "5 小时前",
  },
  {
    id: 3,
    author: "理工男也有春天",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20silhouette%20with%20teal%20gradient%20background%2C%20simple%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20facial%20details&width=80&height=80&seq=avatar-03&orientation=squarish",
    content:
      "《三体》剧版超出预期！特效和剧情还原度都在线，尤其是古筝行动那一段，看得我鸡皮疙瘩都起来了。感谢草民影院让我第一时间看到这部神作。",
    drama: "三体",
    time: "1 天前",
  },
  {
    id: 4,
    author: "怀旧剧场",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20silhouette%20with%20rose%20gradient%20background%2C%20simple%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20facial%20details&width=80&height=80&seq=avatar-04&orientation=squarish",
    content:
      "找了很久的老剧居然在这里找到了！《繁花》的4K修复版画质惊艳，老上海的韵味透过高清画面更加动人。收藏了，以后就在这儿看剧了。",
    drama: "繁花",
    time: "2 天前",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-4k-line",
    title: "真高清画质",
    description: "全站1080P高清片源，部分热剧支持4K画质，告别模糊和锯齿，享受影院级观影体验。",
  },
  {
    id: 2,
    icon: "ri-speed-up-line",
    title: "极速加载",
    description: "全球CDN加速节点覆盖，即点即看无需等待，拖动进度条秒响应，追剧不卡顿。",
  },
  {
    id: 3,
    icon: "ri-refresh-line",
    title: "同步更新",
    description: "与播出平台同步更新，新剧上线24小时内入库，让你永远走在追剧第一线。",
  },
  {
    id: 4,
    icon: "ri-shield-check-line",
    title: "纯净观影",
    description: "无弹窗广告，无强制跳转，无恶意插件，给你一个干干净净的追剧环境。",
  },
  {
    id: 5,
    icon: "ri-smartphone-line",
    title: "多端同步",
    description: "支持手机、平板、电脑无缝切换，追剧进度自动同步，随时随地都能接着看。",
  },
];

export const rankingData = [
  {
    rank: 1,
    title: "庆余年 第二季",
    category: "古装权谋",
    hot: "986万热度",
    trend: "up",
  },
  { rank: 2, title: "繁花", category: "年代商战", hot: "852万热度", trend: "up" },
  { rank: 3, title: "黑暗荣耀", category: "复仇悬疑", hot: "768万热度", trend: "up" },
  { rank: 4, title: "三体", category: "科幻巨制", hot: "691万热度", trend: "stable" },
  { rank: 5, title: "狂飙", category: "扫黑刑侦", hot: "623万热度", trend: "down" },
  { rank: 6, title: "长相思", category: "仙侠古装", hot: "587万热度", trend: "up" },
];

export const mediaData = [
  {
    id: 1,
    title: "《庆余年第二季》幕后特辑",
    type: "花絮",
    duration: "15:32",
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Chinese%20historical%20drama%20film%20set%20with%20cameras%20and%20crew%2C%20traditional%20costumes%2C%20warm%20set%20lighting%2C%20cinematic%20documentary%20style%2C%20no%20text&width=800&height=500&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "《繁花》经典场景回顾",
    type: "剧评",
    duration: "22:10",
    image:
      "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20restaurant%20interior%20with%20round%20tables%20and%20red%20lanterns%2C%20vintage%20Chinese%20decor%2C%20warm%20nostalgic%20lighting%2C%20cinematic%20composition%2C%20rich%20amber%20tones%2C%20no%20text&width=800&height=500&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "《三体》特效制作揭秘",
    type: "幕后",
    duration: "18:47",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20visual%20effects%20studio%20with%20large%20screens%20showing%20space%20scenes%2C%20digital%20artists%20working%2C%20cool%20blue%20ambient%20lighting%2C%20modern%20tech%20environment%2C%20cinematic%20style%2C%20no%20text&width=800&height=500&seq=media-03&orientation=landscape",
  },
  {
    id: 4,
    title: "《黑暗荣耀》名场面混剪",
    type: "剪辑",
    duration: "08:55",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20drama%20intense%20confrontation%20scene%20between%20two%20women%20in%20elegant%20modern%20setting%2C%20dramatic%20lighting%20contrast%2C%20emotional%20tension%2C%20cinematic%20close%20up%20composition%2C%20no%20text&width=800&height=500&seq=media-04&orientation=landscape",
  },
  {
    id: 5,
    title: "2024暑期档追剧指南",
    type: "盘点",
    duration: "12:20",
    image:
      "https://readdy.ai/api/search-image?query=Summer%20evening%20outdoor%20movie%20screening%20with%20string%20lights%2C%20comfortable%20seating%2C%20warm%20golden%20hour%20atmosphere%2C%20relaxed%20vibe%2C%20cinematic%20lifestyle%20photography%2C%20no%20text&width=800&height=500&seq=media-05&orientation=landscape",
  },
];

export const topicsData = [
  { id: 1, name: "#庆余年第二季大结局", hot: "128万讨论" },
  { id: 2, name: "#繁花4K修复版", hot: "96万讨论" },
  { id: 3, name: "#黑暗荣耀复仇爽剧", hot: "87万讨论" },
  { id: 4, name: "#三体网飞vs腾讯", hot: "74万讨论" },
  { id: 5, name: "#狂飙封神演技", hot: "68万讨论" },
  { id: 6, name: "#唐朝诡事录之西行", hot: "59万讨论" },
  { id: 7, name: "#漫长的季节", hot: "52万讨论" },
  { id: 8, name: "#古装剧文艺复兴", hot: "45万讨论" },
  { id: 9, name: "#韩剧复仇女主", hot: "41万讨论" },
  { id: 10, name: "#美剧IP改编潮", hot: "37万讨论" },
  { id: 11, name: "#暑期追剧清单", hot: "33万讨论" },
];

export const aboutData = {
  title: "关于草民影院",
  content:
    "草民影院是一个专注于电视剧在线观看的综合平台，致力于为广大剧迷提供高清、流畅、便捷的追剧体验。我们聚合了国产剧、韩剧、美剧、日剧、泰剧等海量优质内容，覆盖古装、悬疑、科幻、爱情、喜剧等全类型题材。",
  vision:
    "无论是最新热播剧还是经典老剧，草民影院都力求以最快的更新速度和最好的画质呈现。我们相信，好的内容值得被更多人看到，好的观影体验应该触手可及。",
  stats: [
    { label: "上线运营", value: "5 年" },
    { label: "覆盖剧集", value: "10000+" },
    { label: "日均用户", value: "50 万+" },
    { label: "更新速度", value: "≤ 2 小时" },
  ],
};

export const faqData = [
  {
    id: 1,
    question: "草民影院的剧集更新速度快吗？",
    answer:
      "非常快。草民影院与播出平台保持同步更新，新剧集上线后通常在2小时内即可在平台观看。热门剧集更是实现了实时同步更新，让你永远走在追剧第一线。",
  },
  {
    id: 2,
    question: "需要注册账号才能观看吗？",
    answer:
      "不需要。草民影院目前所有剧集均可免费直接观看，无需注册或登录。我们致力于提供最便捷的观影体验，打开即看，没有任何门槛。未来推出的收藏和历史记录功能会需要简单注册。",
  },
  {
    id: 3,
    question: "支持哪些设备观看？画质如何？",
    answer:
      "草民影院全面支持手机、平板和电脑端观看，页面自适应屏幕尺寸。所有剧集默认提供1080P高清画质，部分热门剧集更支持4K超高清画质，让你享受影院级的观影体验。",
  },
  {
    id: 4,
    question: "遇到播放问题或想推荐片单怎么办？",
    answer:
      "你可以通过页面底部的「联系我们」区域发送邮件到 contact@caomin.tv，或关注微信公众号「草民影院」留言。我们每天都有专人处理用户反馈，你的每一条建议我们都会认真对待。",
  },
];

export const appData = {
  title: "草民影院 APP",
  subtitle: "随时随地，追剧不停",
  description:
    "下载草民影院APP，享受离线缓存、弹幕互动、追剧提醒等专属功能。手机端观影体验全面优化，流量消耗更低，加载更快。",
  features: ["离线缓存随时看", "弹幕互动一起聊", "追剧更新秒提醒", "画质智能适配"],
  qrImage:
    "https://readdy.ai/api/search-image?query=Modern%20minimalist%20QR%20code%20design%20on%20clean%20white%20background%20with%20subtle%20warm%20red%20accents%2C%20contemporary%20tech%20style%2C%20clean%20geometric%20pattern%2C%20high%20contrast%20black%20and%20white&width=300&height=300&seq=qr-code-01&orientation=squarish",
  appImage:
    "https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20video%20streaming%20app%20interface%20with%20drama%20thumbnails%2C%20modern%20dark%20UI%20design%20with%20warm%20red%20accents%2C%20clean%20minimal%20layout%2C%20floating%20phone%20on%20neutral%20background%2C%20product%20photography%20style&width=600&height=800&seq=app-mockup-01&orientation=portrait",
  badges: [
    { label: "iOS 下载", icon: "ri-apple-line" },
    { label: "Android 下载", icon: "ri-android-line" },
  ],
};